<template>
    <div style="cursor: pointer;">
        <span class="icon-printer"></span>
        <a class="link-lighter" style="color:#4d8ab7" v-bind:href="$basePath+manualUrl" target="_blank"><slot name="label"></slot></a>
    </div>
</template>

<script>
    export default {
        props: ['manualUrl'],
    }
</script>